import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPrimaryBrandLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 0C9.848 0 0 9.848 0 22s9.848 22 22 22 22-9.848 22-22S34.152 0 22 0zm0 31.554A9.55 9.55 0 0112.446 22 9.55 9.55 0 0122 12.446 9.55 9.55 0 0131.554 22 9.55 9.55 0 0122 31.554z",
    fill: "#08031D"
  })));
}

export { SvgPrimaryBrandLogo as ReactComponent };
